import { assertValidVersion } from "@tsparticles/engine";
import { Pauser } from "./Pauser.js";
export async function loadExternalPauseInteraction(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addInteractor("externalPause", container => {
        return Promise.resolve(new Pauser(container));
    }, refresh);
}
